import { useTranslation } from 'react-i18next';
import { Button } from '@parrot-software/design-system';
import { Play } from '@parrot-software/design-system/icons';
import { SUBSCRIPTION_ACADEMY_LINKS } from '@subscriptions/presentation/utils';

/**
 * SubscriptionPageHeader - Page header with title, description, and separator
 *
 * Displays "Suscripción" title with play icon and description text.
 */
export const SubscriptionPageHeader = () => {
  const { t } = useTranslation('subscriptions');

  const handlePlayClick = () => {
    window.open(SUBSCRIPTION_ACADEMY_LINKS.SUBSCRIPTION, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="px-6 py-4">
      <div className="flex flex-col gap-3">
        <div className="flex items-center gap-6">
          <div className="flex flex-col gap-0.5">
            <div className="flex items-center gap-2">
              <h1 className="text-2xl font-semibold text-foreground">{t('page.title')}</h1>
              <Button
                aria-label="Ver tutorial"
                className="w-6 h-6 rounded-full border-[1.5px] border-primary text-primary bg-transparent hover:bg-red-50 hover:text-primary transition-colors"
                onClick={handlePlayClick}
                size="icon"
                title="Ver tutorial"
                variant="ghost"
              >
                <Play className="w-3! h-3!" />
              </Button>
            </div>

            <p className="text-base text-muted-foreground">{t('page.description')}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
